module.exports = __webpack_public_path__ + "sz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sz.svg
// module id = 828
// module chunks = 0